import { inject, Injectable } from '@angular/core';
import { ConnectionHttpService } from '@softline/core';
import { FieldOkService } from '@softline/dynamic';
import { Observable } from 'rxjs';

/** Raw field-ok lookup row for an employee (endpoint `lstfix`). */
export interface EmployeeLookupRow {
  id: number;
  /** Backend field-ok fields (German, from the `lstfix` endpoint). */
  persnr: number;
  kurzbez: string;
  beruf: string;
}

@Injectable({ providedIn: 'root' })
export class EmployeeLookupService {
  private readonly fieldOkService = new FieldOkService<
    EmployeeLookupRow,
    EmployeeLookupRow
  >(inject(ConnectionHttpService), 'lstfix');

  query(): Observable<EmployeeLookupRow[]> {
    return this.fieldOkService.query({
      filter: '',
      multiValued: false,
      parameters: {},
      maxAbfrageResults: 1000,
    });
  }
}
